let serverTime = {
  content: 1560819600,
  desc: "successful",
  result: 0,
};
export default serverTime;
